import styled from "styled-components";
import { borders } from "@sonder/ui/source/styled/theme";

export const PanelHeader = styled.section`
  grid-area: header;
  border-left: ${borders.standard};
`;
